// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"f5_D_","value":"EE5G3","icon":"CZRdI"};